import { render, staticRenderFns } from "./ManageWorkflows.vue?vue&type=template&id=2553219a&scoped=true"
import script from "./ManageWorkflows.vue?vue&type=script&lang=js"
export * from "./ManageWorkflows.vue?vue&type=script&lang=js"
import style0 from "./ManageWorkflows.vue?vue&type=style&index=0&id=2553219a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553219a",
  null
  
)

export default component.exports